import { render, staticRenderFns } from "./TopicsView.vue?vue&type=template&id=7ea695d8&"
import script from "./TopicsView.vue?vue&type=script&lang=js&"
export * from "./TopicsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports